import React from "react";

const Section2DataController = () => (
  <>
    <h2>2. Data Controller and Contact Information</h2>
    <p>
    Comparedly Ltd., a duly established entity, stands as the primary data controller 
    with respect to the personal data collected and processed through the comparedly.com 
    platform. The registered legal address of Comparedly Ltd. is 8 Hart Avenue, Elmstead, 
    Colchester. For all inquiries, 
    requests, or communications pertaining to this Privacy Policy or the handling of 
    personal data, users are directed to contact our dedicated privacy team via the 
    following email address: privacy@comparedly.com. Considering the nature and scale 
    of its data processing activities, Comparedly Ltd. has appointed a Data Protection 
    Officer (DPO), whose can be contacted via the following email address: 
    notice@comparedly.com. 
    The designation of a DPO underscores Comparedly Ltd.'s 
    commitment to ensuring ongoing compliance with data protection regulations.
    </p>
  </>
);

export default Section2DataController;
